const resources = {
    via: 'via'
};

export default function getResource(label) {
    return resources[label];
}
